export enum RedirectType {
    Default = 'default',
    Expired = 'expired',
    PostLogin = 'postLogin',
}

class SystemRedirect {
    redirects: Record<RedirectType, string | false | undefined>;

    constructor() {
        this.redirects = {
            [RedirectType.Default]: undefined,
            [RedirectType.PostLogin]: undefined,
            [RedirectType.Expired]: undefined,
        };
    }

    setRedirect(type: RedirectType, url: string | false) {
        if (url) {
            localStorage.setItem(`${type}-redirect`, url);
            this.redirects[type] = url;
        }
    }

    removeRedirect(type: RedirectType) {
        localStorage.removeItem(`${type}-redirect`);
    }

    getRedirect(type: RedirectType) {
        return localStorage.getItem(`${type}-redirect`);
    }
}

// TODO: This isn't where we should instantiate singletons.
export const RedirectSingleton = new SystemRedirect();
